import Header from "@/components/Footer/Header";
import FooterFooter from "@/components/Footer/Footer";

// Static footer data for error pages - no async calls needed
const staticFooterData = {
  edx: {
    label: "edx",
    childItems: {
      nodes: [
        { label: "About", url: "/about-us" },
        { label: "edX for Business", url: "/business" },
        { label: "Affiliates", url: "/affiliate-program" },
        { label: "Open edX", url: "https://openedx.org/" },
        { label: "Careers", url: "/careers" },
        { label: "News", url: "/news-announcements" },
      ],
    },
  },
  connect: {
    label: "Connect",
    childItems: {
      nodes: [
        { label: "Idea Hub", url: "/resources" },
        {
          label: "Contact Us",
          url: "https://courses.edx.org/support/contact_us",
        },
        { label: "Help Center", url: "https://support.edx.org/" },
        { label: "Security", url: "/policy/security" },
        { label: "Media Kit", url: "/media-kit" },
      ],
    },
  },
  legal: {
    label: "Legal",
    childItems: {
      nodes: [
        { label: "Terms of Service & Honor Code", url: "/edx-terms-service" },
        { label: "Privacy Policy", url: "/edx-privacy-policy" },
        { label: "Cookie Policy", url: "/edx-privacy-policy/cookies" },
        { label: "Accessibility Policy", url: "/accessibility" },
        { label: "Trademark Policy", url: "/trademarks" },
        { label: "Modern Slavery Statement", url: "/modern-slavery-statement" },
        { label: "Sitemap", url: "/sitemap" },
        { label: "Your Privacy Choices", url: "#" },
      ],
    },
  },
};

const StaticSecondaryLinks = () => {
  return (
    <div className="flex flex-wrap justify-between">
      <div className="mr-12 mb-6">
        <span className="text-base text-left pb-6 mt-0 font-bold">
          {staticFooterData.edx.label}
        </span>
        <ul className="my-6 list-none">
          {staticFooterData.edx.childItems.nodes.map((link) => (
            <li key={link.label} className="mb-2 hover:underline text-base">
              <a className="text-white hover:text-white" href={link.url}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="mr-12 mb-6">
        <span className="text-base text-left pb-6 mt-0 font-bold">
          {staticFooterData.connect.label}
        </span>
        <ul className="my-6 list-none">
          {staticFooterData.connect.childItems.nodes.map((link) => (
            <li key={link.label} className="mb-2 hover:underline text-base">
              <a className="text-white hover:text-white" href={link.url}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="mb-6 grow">
        <span className="text-base text-left pb-6 mt-0 font-bold">
          {staticFooterData.legal.label}
        </span>
        <ul className="my-6 list-none">
          {staticFooterData.legal.childItems.nodes.map((link) => (
            <li key={link.label} className="mb-2 hover:underline text-base">
              {link.label === "Your Privacy Choices" ? (
                <a
                  className="text-white hover:text-white"
                  href={link.url}
                  onClick={(e) => {
                    e.preventDefault();
                    if (
                      typeof window !== "undefined" &&
                      (window as any).OneTrust
                    ) {
                      (window as any).OneTrust.ToggleInfoDisplay();
                    }
                  }}
                >
                  {link.label}
                </a>
              ) : (
                <a className="text-white hover:text-white" href={link.url}>
                  {link.label}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default function StaticFooter() {
  return (
    <div className="bg-primary text-primary-foreground pt-16">
      <footer className="flex justify-between max-w-screen-xl mx-auto px-4 pb-4">
        <div className="flex flex-col w-full">
          <Header />
          <StaticSecondaryLinks />
          <FooterFooter />
        </div>
      </footer>
    </div>
  );
}
